import React, { useContext, useEffect, useState } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import EveryOption from './components/EveryOption';
// import EveryStartingSelect from './components/EveryStartingSelect';
import SpecificOfWeekSelectors from './components/SpecificOfWeekSelectors';
// import LastDayOfMonthOption from './components/LastDayOfMonthOption';
// import LastWeekdayOfMonthOption from './components/LastWeekdayOfMonthOption';
// import EveryStartingOfMonthSelect from './components/EveryStartingOfMonthSelect';
import SpecificOfMonthSelectors from './components/SpecificOfMonthSelectors';
// import LastOfMonthSelect from './components/LastOfMonthSelect';
// import LastBeforeEndSelect from './components/LastBeforeEndSelect';
// import NearestWeekdaySelect from './components/NearestWeekdaySelect';
// import OnDayOfMonthSelect from './components/OnDayOfMonthSelect';
import {
	CronGeneratorContext,
	ICronGeneratorContext,
	TabOptions,
} from '../../../../../../cronGeneratorState/cronGeneratorContext';
import classNames from 'classnames';
import style from './DayTab.module.scss';

interface ITab {
	isVisible: boolean;
}

const DayTab: React.FC<ITab> = ({ isVisible }) => {
	const { setFieldValue } = useContext<ICronGeneratorContext>(CronGeneratorContext);
	// const [checkedOption, setCheckedOption] = useState<TabOptions>(TabOptions.EVERY_OPTION);
	const [checkedOption, setCheckedOption] = useState<TabOptions>(TabOptions.SPECIFIC_OF_WEEK_OPTION);
	const [everyResult, setEveryResult] = useState<string>('');
	// const [everyStartingResult, setEveryStartingResult] = useState<string>('');
	// const [everyStartingOfMonthResult, setEveryStartingOfMonthResult] = useState<string>('');
	const [specificDayOfWeekResult, setSpecificDayOfWeekResult] = useState<string>('');
	const [specificDayOfMonthResult, setSpecificDayOfMonthResult] = useState<string>('');
	// const [lastDayOfMonthResult, setLastDayOfMonthResult] = useState<string>('');
	// const [lastWeekdayOfMonthResult, setLastWeekdayOfMonthResult] = useState<string>('');
	// const [lastOfMonthResult, setLastOfMonthResult] = useState<string>('');
	// const [lastBeforeEndResult, setLastBeforeEndResult] = useState<string>('');
	// const [nearestWeekdayResult, setNearestWeekdayResult] = useState<string>('');
	// const [onDayOfMonthResult, setOnDayOfMonthResult] = useState<string>('');

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getCheckedValue = () => {
		switch (checkedOption) {
			case TabOptions.EVERY_OPTION:
				return everyResult;
			// case TabOptions.EVERY_STARTING_OPTION:
			// 	return everyStartingResult;
			// case TabOptions.EVERY_STARTING_OF_MONTH_OPTION:
			// 	return everyStartingOfMonthResult;
			case TabOptions.SPECIFIC_OF_WEEK_OPTION:
				return specificDayOfWeekResult;
			case TabOptions.SPECIFIC_OF_MONTH_OPTION:
				return specificDayOfMonthResult;
			// case TabOptions.LAST_DAY_OF_MONTH_OPTION:
			// 	return lastDayOfMonthResult;
			// case TabOptions.LAST_WEEKDAY_OF_MONTH_OPTION:
			// 	return lastWeekdayOfMonthResult;
			// case TabOptions.LAST_OF_MONTH_OPTION:
			// 	return lastOfMonthResult;
			// case TabOptions.LAST_BEFORE_END_OPTION:
			// 	return lastBeforeEndResult;
			// case TabOptions.NEAREST_WEEKDAY_OPTION:
			// 	return nearestWeekdayResult;
			// case TabOptions.ON_DAY_OF_MONTH_OPTION:
			// 	return onDayOfMonthResult;
			default:
				// return everyResult;
				return specificDayOfWeekResult;
		}
	};
	const fieldValue = getCheckedValue();

	const handleOptionChange = (e: RadioChangeEvent) => {
		setCheckedOption(e.target.value);
	};

	const setDayOfWeek = (fieldValue: string) => {
		setFieldValue('dayOfWeek', fieldValue || '*');
	};

	const setDayOfMonth = (fieldValue: string) => {
		setFieldValue('dayOfMonth', fieldValue || '*');
	};

	useEffect(() => {
		const isDayOfWeekOption = [
			TabOptions.EVERY_OPTION,
			TabOptions.EVERY_STARTING_OPTION,
			TabOptions.SPECIFIC_OF_WEEK_OPTION,
			TabOptions.LAST_OF_MONTH_OPTION,
			TabOptions.ON_DAY_OF_MONTH_OPTION,
		].some((el) => el === checkedOption);

		if (isDayOfWeekOption) {
			setDayOfWeek(fieldValue);
			setDayOfMonth('?');
		} else {
			setDayOfMonth(fieldValue);
			setDayOfWeek('?');
		}
		isDayOfWeekOption ? setDayOfWeek(fieldValue) : setDayOfMonth(fieldValue);
	}, [fieldValue, checkedOption]);

	return (
		<Radio.Group
			className={containerClasses}
			value={checkedOption}
			onChange={handleOptionChange}
			data-test="DayTab">
			<EveryOption onSetResult={setEveryResult} />
			{/*<EveryStartingSelect onSetResult={setEveryStartingResult} />*/}
			{/*<EveryStartingOfMonthSelect onSetResult={setEveryStartingOfMonthResult} />*/}
			<SpecificOfWeekSelectors onSetResult={setSpecificDayOfWeekResult} />
			<SpecificOfMonthSelectors onSetResult={setSpecificDayOfMonthResult} />
			{/*<LastDayOfMonthOption onSetResult={setLastDayOfMonthResult} />*/}
			{/*<LastWeekdayOfMonthOption onSetResult={setLastWeekdayOfMonthResult} />*/}
			{/*<LastOfMonthSelect onSetResult={setLastOfMonthResult} />*/}
			{/*<LastBeforeEndSelect onSetResult={setLastBeforeEndResult} />*/}
			{/*<NearestWeekdaySelect onSetResult={setNearestWeekdayResult} />*/}
			{/*<OnDayOfMonthSelect onSetResult={setOnDayOfMonthResult} />*/}
		</Radio.Group>
	);
};

export default DayTab;
